import React, { useLayoutEffect, useRef } from 'react'
import { Autoplay, Pagination } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'

import styles from './carousel.module.scss'

interface CarouselProps {
  slides: JSX.Element[]
}

const Carousel = ({ slides }: CarouselProps) => {
  const swiperRef = useRef<any>(null)

  useLayoutEffect(() => {
    const randomTime = Math.floor(Math.random() * 5 + 2) * 1000
    const timeout = setTimeout(() => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      swiperRef.current?.swiper.slideNext()
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      swiperRef.current?.swiper.autoplay.start()
    }, randomTime)

    return () => {
      clearTimeout(timeout)
    }
  }, [])

  return (
    <Swiper
      ref={swiperRef}
      className={styles.carousel}
      modules={[Pagination, Autoplay]}
      spaceBetween={10}
      slidesPerView={1}
      autoplay={{ delay: 6500 }}
      speed={1000}
      loop={true}
      pagination={{
        clickable: true,
      }}
    >
      {slides.map((slide, index) => (
        <SwiperSlide key={index}>{slide}</SwiperSlide>
      ))}
    </Swiper>
  )
}

export default Carousel
